import { Link } from "react-router-dom";
import { tableBooleanEnums } from "../../table/tableFeatures/tableEnums";
import { thousandSeparator } from "../../../features/dataFormatFunctions/dataFormatter";
import { IndorImages, getIndorImageSrc } from "../../../features";
import type { DataGridTypes } from "devextreme-react/cjs/data-grid";
import { getHighlightObjectGeometry } from "../../map/mapFeatures/mapFunctions/highLightObjectFunctions/highLightObjectFunctions";
import { upgradedDeepGet } from "../../../features/dataFunctions/dataFunctions";
const square_check = require('../../../assets/images/fontAwesomeIcons/square-check-regular.svg').default
const square_cross = require('../../../assets/images/fontAwesomeIcons/square-xmark-solid.svg').default

const noWrapFields = ['Position', 'Ending', 'MaintenancePosition', 'MaintenanceEnding'];

// Шаблон ячейки таблицы, содержащей активную ссылку
export function getMapLinkBody(rowData: any, bodyImageSrc: string, field: any) {
    return (
        <div>
            {(rowData.MapLink && rowData.HasGeometry && field === 'MapLink') &&
                <Link to={`${rowData.MapLink}`}>
                    <img alt="map-link" src={bodyImageSrc} title="" />
                </Link>
            }
            {(rowData.ObjectCardLink && field === 'ObjectCardLink') &&
                <Link to={`${rowData.ObjectCardLink}`}>
                    <img alt="map-link" src={bodyImageSrc} />
                </Link>
            }
            {(field === 'MapLink' && !rowData.HasGeometry) &&
                <div>
                    <span>—</span>
                </div>
            }
        </div>
    );
}

// Шаблон ячейки таблицы, содержащей активную ссылку
export function getMapHighlightBody(rowData: any, bodyImageSrc: string, field: any, tableValueUrl: string) {
    return (
        <div>
            {(rowData.MapLink && rowData.HasGeometry && field === 'MapLink') &&
                <img alt="map-link" src={bodyImageSrc} onClick={() => getHighlightObjectGeometry(rowData?.InfoObjectID, tableValueUrl)} />
            }
            {(field === 'MapLink' && !rowData.HasGeometry) &&
                <div>
                    <span>—</span>
                </div>
            }
        </div>
    );
}

export function getMapLinkHeaderCell() {
    return <img src={getIndorImageSrc(IndorImages.Map, 20)} alt="map-icon" className="road-direction-on-map-icon" title="На карте" />
}

// Шаблон ячейки таблицы, содержащей булево значение
export function getBooleanBody(rowData: any, field: any) {
    return (
        <div>
            {(tableBooleanEnums[field] !== undefined && rowData[field] != null) ?
                <>
                    {
                        rowData[field] == "Да"
                            ?
                            <img style={{ marginLeft: "25px" }} src={square_check} width="23px" height="23px" />
                            :
                            <img style={{ marginLeft: "25px" }} src={square_cross} width="20px" height="22px" />
                    }
                </>
                :
                <div style={{ marginLeft: "25px" }}>—</div>
            }
        </div>
    )
}

// Шаблон ячейки таблицы, содержащей булево значение
export function getBooleanBodyDevExtreme(data: DataGridTypes.ColumnCellTemplateData) {
    let dataField: any = data.column.dataField
    let text = data?.text
    return (
        <div>
            {(tableBooleanEnums[dataField] !== undefined && text != null && text != "") ?
                <>
                    {
                        text == "Да"
                            ?
                            <img style={{ marginLeft: "25px" }} src={square_check} width="23px" height="23px" />
                            :
                            <img style={{ marginLeft: "25px" }} src={square_cross} width="20px" height="22px" />
                    }
                </>
                :
                <div style={{ marginLeft: "25px" }}>—</div>
            }
        </div>
    )
}

// Шаблон ячейки таблицы из раздела "Таблицы" для обработки отсутствующего значения
export function getObjectsTableBasicBody(rowData: any, field: any, valueFormat?: any) {
    const data = upgradedDeepGet(rowData, field, valueFormat)
    return (
        <div>
            {(data || data === 0)
                ?
                <div>
                    <span>{data}</span>
                </div>
                :
                <div>—</div>
            }
        </div>
    );
}

// Шаблон ячейки таблицы из раздела "Таблицы" для обработки отсутствующего значения
export function getObjectsTableBasicBodyDevExtreme(data: DataGridTypes.ColumnCellTemplateData) {
    const checkFotMaintenanceField = (data.column.dataField == 'MaintenancePosition' || data.column.dataField == 'MaintenanceEnding') && data.text?.includes(';')

    return (
        <div>
            {(data.text || data.text === '0')
                ?
                <div>
                    {checkFotMaintenanceField
                        ?
                        data.text
                        :
                        <>
                            {!noWrapFields.includes(`${data.column.dataField}`)
                                ?
                                <span>{data.text}</span>
                                :
                                <span>{data.text}</span>
                            }
                        </>
                    }
                </div>
                :
                <div>—</div>
            }
        </div>
    );
}

// Шаблон ячейки таблицы из раздела "Аналитика" для обработки отсутствующего значения
export function getAnalyticsTableBasicBody(rowData: any, field: any) {
    return (
        <div>
            {rowData[field]
                ?
                <div>
                    {
                        typeof rowData[field] === "number"
                            ?
                            thousandSeparator(rowData[field]?.toFixed(2)?.toString())
                            :
                            <div>
                                {field === 'Количество'
                                    ?
                                    thousandSeparator(parseFloat(rowData[field])?.toFixed(2)?.toString())
                                    :
                                    rowData[field]
                                }
                            </div>
                    }
                </div>
                :
                <div>—</div>
            }
        </div>
    );
}

// Шаблон ячейки таблицы из раздела "Диагностика - результаты измерений" для обработки отсутствующего значения
// и окрашивания критических значений
export function getMeasureResultsTableBasicBody(rowData: any, field: any, fieldsNoToWrap: any, type: any) {
    let currentMeasureAdmissibleValue
    let currentMeasureLessIsBetterMark
    if (type === 'RoadMeasureResults' && rowData['AdmissibleValue']) {
        currentMeasureAdmissibleValue = parseFloat(rowData['AdmissibleValue']?.replace(',', '.')?.replace(/ /, ''))
        currentMeasureLessIsBetterMark = rowData['LessIsBetter']
    }
    const noWrap = fieldsNoToWrap.filter((item: any) => item === field)[0]
    return (
        <div>
            {((rowData[field] || rowData[field] === 0))
                ?
                <div>
                    {/* результаты измерений */}
                    {type === 'RoadMeasureResults' &&
                        <>
                            {/* есть ли предельно допустимое значение */}
                            {currentMeasureAdmissibleValue != null
                                ?
                                <>
                                    {/* есть ли разделение значений по полосам */}
                                    {(field.match(/Forward\dValue/) || field.match(/Reverse\dValue/))
                                        ?
                                        // есть разделение по полосам
                                        <>
                                            {/* проверка допустимости значения относительно предельно допустимого */}
                                            {currentMeasureLessIsBetterMark
                                                ?
                                                <>
                                                    {/* меньшее значение - лучше */}
                                                    {parseFloat(rowData[field]?.replace(',', '.')?.replace(/ /, '')) < currentMeasureAdmissibleValue
                                                        ? <span  >{rowData[field]}</span>
                                                        : (parseFloat(rowData[field]?.replace(',', '.')?.replace(/ /, '')) == currentMeasureAdmissibleValue
                                                            ?
                                                            <span style={{ color: 'orange' }}>{rowData[field]}</span>
                                                            :
                                                            <span style={{ color: 'red' }}>{rowData[field]}</span>
                                                        )
                                                    }
                                                </>
                                                :
                                                <>
                                                    {/* большее значение - лучше */}
                                                    {parseFloat(rowData[field]?.replace(',', '.')?.replace(/ /, '')) > currentMeasureAdmissibleValue
                                                        ? <span  >{rowData[field]}</span>
                                                        : (parseFloat(rowData[field]?.replace(',', '.')?.replace(/ /, '')) == currentMeasureAdmissibleValue
                                                            ?
                                                            <span style={{ color: 'orange' }}>{rowData[field]}</span>
                                                            :
                                                            <span style={{ color: 'red' }}>{rowData[field]}</span>
                                                        )}
                                                </>
                                            }
                                        </>
                                        :
                                        // нет разделения по полосам
                                        <>
                                            {(noWrap != null)
                                                ?
                                                <>
                                                    {typeof rowData[field] === 'string'
                                                        ?
                                                        <div className="text-nowrap">
                                                            <span>{rowData[field]?.includes(';') ? rowData[field].split(';')[0] : rowData[field]}</span>
                                                        </div>
                                                        :
                                                        <span>{rowData[field]}</span>
                                                    }
                                                </>
                                                :
                                                <span>{rowData[field]}</span>
                                            }
                                        </>
                                    }
                                </>
                                :
                                // нет предельно допустимого значения
                                <>
                                    {(noWrap != null)
                                        ?
                                        <>
                                            {typeof rowData[field] === 'string'
                                                ?
                                                <div className="text-nowrap">
                                                    <span>{rowData[field]?.includes(';') ? rowData[field].split(';')[0] : rowData[field]}</span>
                                                </div>
                                                :
                                                <span>{rowData[field]}</span>
                                            }
                                        </>
                                        :
                                        <span>{rowData[field]}</span>
                                    }
                                </>
                            }
                        </>
                    }
                    {/* дефекты */}
                    {(type != 'RoadMeasureResults') &&
                        <>
                            {(noWrap != null)
                                ?
                                <>
                                    {typeof rowData[field] === 'string'
                                        ?
                                        <div className="text-nowrap">
                                            <span>{rowData[field]?.includes(';') ? rowData[field].split(';')[0] : rowData[field]}</span>
                                        </div>
                                        :
                                        <span>{rowData[field]}</span>
                                    }
                                </>
                                :
                                <>
                                    {field === 'LeftDefectsStr' || field === 'RightDefectsStr'
                                        ?
                                        <div>
                                            {rowData[field]?.includes(';')
                                                ?
                                                <div className="d-flex flex-column align-items-end">
                                                    {rowData[field]?.split(';').map((defect: any) => {
                                                        return <p style={{ margin: '0', width: '200px' }}>{defect};</p>
                                                    })}
                                                </div>
                                                :
                                                <div>
                                                    {rowData[field]}
                                                </div>
                                            }
                                        </div>
                                        :
                                        <div>
                                            <span>{rowData[field]}</span>
                                        </div>
                                    }
                                </>
                            }
                        </>
                    }
                </div>
                :
                <div>—</div>
            }
        </div >
    );
}


// Шаблон ячейки таблицы из раздела "Диагностика - участки диагностики" для обработки отсутствующего значения 
// и окрашивания критических значений
export function getDiagnosticsSegmentsTableBasicBody(rowData: any, field: any, fieldsNoToWrap: any, type: any, currentMeasureAdmissibleValue: any, currentMeasureLessIsBetterMark: any) {
    const noWrap = fieldsNoToWrap.filter((item: any) => item === field)[0]
    return (
        <div>
            {((rowData[field] || rowData[field] === 0))
                ?
                <div>
                    {type === 'RoadMeasureResults' &&
                        <>
                            {currentMeasureAdmissibleValue != null
                                ?
                                <>
                                    {(field.match(/Forward\dValue/) || field.match(/Reverse\dValue/))
                                        ?
                                        <>
                                            {currentMeasureLessIsBetterMark
                                                ?
                                                <>
                                                    {parseFloat(rowData[field]?.replace(',', '.')?.replace(/ /, '')) < currentMeasureAdmissibleValue
                                                        ? <span  >{rowData[field]}</span>
                                                        : (parseFloat(rowData[field]?.replace(',', '.')?.replace(/ /, '')) == currentMeasureAdmissibleValue
                                                            ?
                                                            <span style={{ color: 'orange' }}>{rowData[field]}</span>
                                                            :
                                                            <span style={{ color: 'red' }}>{rowData[field]}</span>
                                                        )
                                                    }
                                                </>
                                                :
                                                <>
                                                    {parseFloat(rowData[field]?.replace(',', '.')?.replace(/ /, '')) > currentMeasureAdmissibleValue
                                                        ? <span  >{rowData[field]}</span>
                                                        : (parseFloat(rowData[field]?.replace(',', '.')?.replace(/ /, '')) == currentMeasureAdmissibleValue
                                                            ?
                                                            <span style={{ color: 'orange' }}>{rowData[field]}</span>
                                                            :
                                                            <span style={{ color: 'red' }}>{rowData[field]}</span>
                                                        )}
                                                </>
                                            }
                                        </>
                                        :
                                        <>
                                            {(noWrap != null)
                                                ?
                                                <div className="text-nowrap">
                                                    <span>{rowData[field].includes(';') ? rowData[field].split(';')[0] : rowData[field]}</span>
                                                </div>
                                                :
                                                <span>{rowData[field]}</span>
                                            }
                                        </>
                                    }
                                </>
                                :
                                <>
                                    {(noWrap != null)
                                        ?
                                        <div className="text-nowrap" >
                                            <span>{rowData[field].includes(';') ? rowData[field].split(';')[0] : rowData[field]}</span>
                                        </div>
                                        :
                                        <span>{rowData[field]}</span>
                                    }
                                </>
                            }
                        </>
                    }
                    {(type != 'RoadMeasureResults') &&
                        <>
                            {(noWrap != null)
                                ?
                                <div className="text-nowrap">
                                    <span>{rowData[field].includes(';') ? rowData[field].split(';')[0] : rowData[field]}</span>
                                </div>
                                :
                                <span>{rowData[field]}</span>
                            }
                        </>

                    }
                </div>
                :
                <div>—</div>
            }
        </div >
    );
}

export function getDateTimeTableBody(rowData: any, field: any) {
    let date = rowData[field].split(' ')[0]
    let time = rowData[field].split(' ')[1]
    return (
        <div>
            {rowData[field]
                ?
                <div>
                    <p className="m-0">
                        {date}
                    </p>
                    <p className="m-0">
                        {time}
                    </p>
                </div>
                :
                <div>—</div>
            }
        </div>
    );
}

// Базовый шаблон ячейки таблицы для обработки отсутствующего значения
export function getBasicTableBasicBody(rowData: any, field: any) {
    return (
        <div>
            {rowData[field]
                ?
                <div>
                    {rowData[field]}
                </div>
                :
                <div>—</div>
            }
        </div>
    );
}
